<template>
    <Page>
        <main>
            <SectionTitle :title="config.ERROR_TITLE"/>
            <SectionPicture>
                <ArtError :color="config.COLOR_PRIMARY" style="width: 400px"/>
            </SectionPicture>
            <SectionText :text="config.ERROR_DESCRIPTION"/>
            <SectionText v-if="isDevelopment" class="stack" :text="error.stack"/>
            <SectionActions>
                <Button :color="config.COLOR_PRIMARY" to="/" outline>
                    {{ config.ERROR_GOBACK }}
                </Button>
                <Button :color="config.COLOR_PRIMARY" @click="onRetry">
                    {{ config.ERROR_RETRY }}
                </Button>
            </SectionActions>
        </main>
    </Page>
</template>
<script>
import { SolutionConsumer } from '../../mixins';
import {
    Page, SectionPicture, SectionTitle, SectionText, SectionActions,
} from '../../components/shared';

export default {
    name: 'Error',
    components: {
        Page, SectionPicture, SectionTitle, SectionText, SectionActions,
    },
    mixins: [SolutionConsumer],
    props: {
        error: {
            type: Error,
            default: null,
        },
    },
    computed: {
        isDevelopment () {
            return process.env.NODE_ENV === 'development';
        },
    },
    methods: {
        onRetry () {
            window.location.reload();
        },
    },

};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/colors';
@import '../../assets/scss/mixins';

main {
    @include container(40px);
    flex-grow: 1;
    align-content: center;
}

.stack {
    @include card(8px);
    margin: 0 auto;
    text-align: left !important;
    font-family: monospace;
    white-space: pre;
}
</style>
